import r from "./useStorageEvent.js";
import { loggedIn as o } from "@propify-tenant-client/services";
import { useState as g } from "react";
const I = () => {
  const [e, t] = g(o());
  return r("id_token", () => {
    t(o());
  }), { isLoggedIn: e };
};
export {
  I as useIsLoggedIn
};
//# sourceMappingURL=useIsLoggedIn.js.map
